import _ from 'lodash'
import {
  hydrate as webSiteHydrate,
  dehydrate as webSiteDehydrate,
} from './web-site'

const profileTypeMapping = {
  1: 'expert',
  2: 'expertSource',
  3: 'secondarySource',
  4: 'administrator',
  5: 'observer',
}

function profileTypeDehydrate(type) {
  return profileTypeMapping[type]
}

function profileTypeHydrate(type) {
  return _.invert(profileTypeMapping)[type]
}

export function dehydrate({
  pk,
  institution,
  location,
  areaOfResearch,
  position,
  department,
  biography,
  webSites,
  language,
  type,
  interests,
}) {
  return {
    pk,
    institution,
    location,
    areaOfResearch,
    position,
    department,
    biography,
    webSites: _.map(webSites, webSiteDehydrate),
    language,
    type: profileTypeDehydrate(type),
    interests,
  }
}

export function hydrate({
  pk,
  institution,
  location,
  areaOfResearch,
  position,
  department,
  biography,
  webSites,
  language,
  type,
  interests,
}) {
  return {
    pk,
    institution,
    location,
    areaOfResearch,
    position,
    department,
    biography,
    language,
    webSites: _.reject(_.map(webSites, webSiteHydrate), { url: null }),
    type: profileTypeHydrate(type),
    interests,
  }
}
